'use strict';

angular.module('directives.iamEvent')

.controller('iamEventGroupController', ['$scope', '$state', 'eventService', function ($scope, $state, eventService) {

    // Show All Events And Tasks?
    $scope.showAllEventsAndTasks = function () {
        if (_.isUndefined($scope.boxContext) || _.isUndefined($scope.boxContext.CorrelatedEventsGroup)) return;

        return $scope.boxContext.CorrelatedEventsGroup.SelectedID === $scope.model.EventGroupID;
    };

    // Go Back
    $scope.goBack = function () {
        $state.go('event', { eventGroupId: null }, { reload: true });
    };

}]);